import React, { useState } from 'react'
import './Contact.css'
import Heading from '../../common/heading/Heading'
import Button from '../../common/Button/Button'
import emailRegexExample from '../../../helpers/emailRegexExample'
import emailjs from '@emailjs/browser'
import toast from 'react-hot-toast'
import { useAppContext } from '../../../utils/context/AppContext'

const Contact = () => {
	const [name, setName] = useState({
		value: '',
		required: true,
		error: '',
	})
	const [email, setEmail] = useState({
		value: '',
		required: true,
		error: '',
	})
	const [make, setMake] = useState({
		value: '',
		required: false,
		error: '',
	})
	const [model, setModel] = useState({
		value: '',
		required: false,
		error: '',
	})
	const [year, setYear] = useState({
		value: '',
		required: false,
		error: '',
	})
	const [message, setMessage] = useState({
		value: '',
		required: true,
		error: '',
	})
	const [sending, setSending] = useState(false)

	const { isValid } = useAppContext()

	const formHasErrors = () => {
		return name.error ||
			!name.value ||
			email.error ||
			!emailRegexExample.test(email.value) ||
			!email.value ||
			message.error ||
			!message.value
			? true
			: false
	}

	const sendEmail = (e) => {
		e.preventDefault()
		let emailMessage

		if (year.value || make.value || model.value) {
			emailMessage += `(${year.value.trim()} ${make.value.trim()} ${model.value.trim()}) `
		}

		emailMessage += `${message.value}`.trim()
		const formInputs = {
			name: name.value,
			email: email.value,
			message: emailMessage,
		}

		if (!isValid) {
			toast.error('Unable to send message, reCAPTCHA failed')
			return
		}
		setSending(true)

		emailjs
			.send(
				process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
				process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID,
				formInputs,
				process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY
			)
			.then((res) => {
				console.log('success')
				setSending(false)
				toast.success('Message sent')
				setName((prev) => ({
					...prev,
					value: '',
				}))
				setEmail((prev) => ({
					...prev,
					value: '',
				}))
				setMake((prev) => ({
					...prev,
					value: '',
				}))
				setModel((prev) => ({
					...prev,
					value: '',
				}))
				setYear((prev) => ({
					...prev,
					value: '',
				}))
				setMessage((prev) => ({
					...prev,
					value: '',
				}))
			})
			.catch((error) => {
				console.log(error)
				setSending(false)
				toast.error('Message failed to send')
			})
	}

	return (
    <section className="contact-section" id="contact">
      <div className="text-block contact-inner">
        <header className="contact-header">
          <Heading eyebrow="Get in touch">Contact Us</Heading>
          <p className="contact-lead">
            Every vehicle is important to us. Tell us about your build and
            we&rsquo;ll be in touch to walk you through the process.
          </p>
        </header>
        <form onSubmit={(e) => sendEmail(e)} className="contact-form">
          <div className="form-rate">
            <span className="form-rate-label">Labor Rate</span>
            <span className="form-rate-value">
              $140<span>/hr</span>
            </span>
          </div>
          <div className="field">
            <span>Name*</span>
            <input
              maxLength={48}
              placeholder="Your name"
              value={name.value}
              onChange={(e) =>
                setName((prev) => ({ ...prev, value: e.target.value }))
              }
            />
          </div>
          <div className="field">
            <span>Email*</span>
            <input
              maxLength={254}
              placeholder="you@example.com"
              value={email.value}
              onChange={(e) =>
                setEmail((prev) => ({ ...prev, value: e.target.value }))
              }
            />
          </div>
          <div className="form-row three">
            <div className="field">
              <span>Make</span>
              <input
                placeholder="Ford"
                value={make.value}
                onChange={(e) =>
                  setMake((prev) => ({ ...prev, value: e.target.value }))
                }
              />
            </div>
            <div className="field">
              <span>Model</span>
              <input
                placeholder="Mustang"
                value={model.value}
                onChange={(e) =>
                  setModel((prev) => ({ ...prev, value: e.target.value }))
                }
              />
            </div>
            <div className="field">
              <span>Year</span>
              <input
                maxLength={4}
                placeholder="2018"
                value={year.value}
                onChange={(e) =>
                  setYear((prev) => {
                    const regex = /^[0-9]*$/;
                    if (!regex.test(e.target.value)) return prev;
                    return { ...prev, value: e.target.value };
                  })
                }
              />
            </div>
          </div>
          <div className="field">
            <span>Message*</span>
            <textarea
              rows="6"
              maxLength={1000}
              placeholder="Tell us about your build..."
              value={message.value}
              onChange={(e) =>
                setMessage((prev) => ({ ...prev, value: e.target.value }))
              }
            />
          </div>
          <Button
            key={2}
            exact={true}
            type="submit"
            stretch
            color={"hsl(198, 100%, 50%)"}
            disabled={formHasErrors() || sending}
          >
            Send Message
          </Button>
        </form>
      </div>
    </section>
  );
}

export default Contact
